<template>
    <div id="navbar-container">
        <nav :class="['navbar is-fixed-top-touch', { 'is-active': showMenu }]" role="navigation" aria-label="main navigation">
            <div class="navbar-brand">
                <router-link class="navbar-item" to="/home">
                    <router-link tag="img" to="/home" src="/static/img/hp-social-int-logo.svg" alt="HP Logo" />
                </router-link>

                <button @click.prevent="showMenu = !showMenu" :class="['navbar-burger', { 'is-active': showMenu }]">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>
            <div :class="['navbar-menu', { 'is-active': showMenu }]" v-if="!hideHeader">
                <div class="navbar-end">
                    <a  class="navbar-item" href="https://biz.hellopeter.com/review-collection-hellopeter">Features</a>
                    <a class="navbar-item" href="https://biz.hellopeter.com/plans">Plans</a>
                    <a class="navbar-item" href="https://biz.hellopeter.com/blog">Resources</a>
                    <a class="navbar-item" href="https://intercom.help/hellopeter/en/">Support</a>
                    <a href="/login" class="button is-button-dark-blue-outline button-nav">SIGN IN</a>
                    <router-link to="/onboard/create/free/monthly" class="button is-button-dark-blue button-nav" v-if="!isSignUpPage">CREATE FREE ACCOUNT</router-link>
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
  export default {
    metaInfo: {
      meta: process.env.NODE_ENV === 'production' ? [
        {
          'name': 'google-site-verification',
          'content': 'PGI8Df1akrJLYTmKQbUvveOzq-oORVhABnox7YB30zE'
        }
      ] : []
    },
    data () {
      return {
        showMenu: false,
        blog_url: process.env.BLOG_URL,
        hideHeaderUrls: ['/onboard/create/free/monthly', '/onboard/create/free'],
        currentUrl: this.$route.path
      }
    },
    computed: {
      isSignUpPage () {
        return this.$route.name === 'Create New Account' || this.$route.name === 'Create New Paid Account'
      },
      hideHeader () {
        return this.hideHeaderUrls.includes(this.currentUrl)
      }
    },
    watch: {
      '$route' () {
        this.showMenu = false
        this.currentUrl = this.$route.path
      }
    }
  }
</script>
<style scoped>

    .router-link-active {
        background-color: #fff;
    }

    #navbar-container {
      width: 100%;
      max-width: 100%;
      border-bottom: solid 1px rgba(112, 112, 112, 0.12);
    }

    nav {
        background-color: #fff;
        color: #30AAE1;
    }

    .navbar-brand > button {
        background-color: #fff;
        color: #2FABE1;
        border: none;
    }

    .navbar-end > a.navbar-item {
        margin-top: 20px;
        margin-bottom: 15px;
        text-transform: uppercase;
        color: #1261a0;
        font-family: Open Sans;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.36;
        letter-spacing: normal;
        height: 40px;
        line-height: 40px;
    }



    .navbar-end > a.is-button-blue-outline {
      margin-left: 30px;
    }

    .button-nav:last-child {
      /*margin-right: 50px;*/
      margin-left: 30px;
    }

    a.navbar-item.is-active, a.navbar-link:hover, a.navbar-link.is-active {
        background-color: #fff;
        color: #30AAE1;
    }

    a.navbar-item:hover {
        background: none;
    }

    @media screen and (max-width: 1023px) {
      .navbar.is-fixed-top-touch {
        border-bottom: solid 1px #d3d3d3;;
      }
    }



    @media screen and (min-width: 1024px) {
      .navbar-end > a.button {
        width: 180px;
        height: 40px;
        margin-top: 20px;
        margin-bottom: 15px;
      }

        .navbar-item:not(:first-child):not(.button) {
            border-top: none !important;
        }

        .navbar-end > a.navbar-item {
            text-transform: uppercase !important;
        }

      .button-nav:last-child {
        margin-right: 0;
      }

    }

    @media screen and (max-width: 1024px) {

        .navbar-burger {
            border: none !important;
        }

        .navbar-menu.is-active {
            background-color: #fff;
            color: #30AAE1;
            border-top: 1px solid #ffffff;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
        }

        nav.is-active {
            background-color: #fff;
            color: #30AAE1;
        }

        .navbar-brand > button {
            border: none;
        }

        .navbar-brand > button.is-active {
            background-color: #fff;
            color: #30AAE1;
        }

        .navbar-end > .navbar-item {
            margin-left: 1rem;
            margin-right: 1rem;
            padding-top: 1rem;
            padding-bottom: 1rem;
        }

        .navbar-item {
            text-transform: none !important;
        }

        .navbar-item:not(:first-child):not(.button) {
            border-top: 1px solid #7e8b95;
        }
    }

    @media screen and (min-width: 1297px) {
      .navbar {
        max-width: 1297px;
        width: 1297px;
        margin: 0 auto;
      }
    }

    .navbar-item img {
      max-height: 100%!important;
    }

    @media screen and (max-width: 767px) {
      .navbar-item img {
        width: 77px;
      }

      .navbar-end > a.navbar-item {
        color: #30aae1;
        font-size: 16px!important;
        text-transform: uppercase!important;
        margin-top: 0!important;
        margin-bottom: 0!important;
        padding: 10px 15px;
        border: none!important;
      }

      .button-nav {
        width: 100%;
      }

      .navbar-end > a.button {
        width: calc(100vw - 60px);
        height: 40px;
        margin: 10px 30px 15px 30px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/layouts/PublicHeader.vue